import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ManageVehicleService } from './manage-vehicle.service';
import { Vehicle } from '../../shared/models/vehicle';
import { AdminService } from '../admin.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../shared/loader/loader.service';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import * as _ from 'lodash';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { Permission } from 'src/modules/shared/models/user-role';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';

@Component({
  selector: 'app-manage-vehicle',
  templateUrl: './manage-vehicle.component.html',
  styleUrls: ['./manage-vehicle.component.scss']
})
export class ManageVehicleComponent implements OnInit {
  public vehicles: Vehicle[];
  public vehiclesFilter: Vehicle[];
  public vehicle: Vehicle;
  public dropdownList = [];
  public alerts: any[] = [];
  public vehiclesModelFilter = [];
  public yearFilter = [];
  public generationFilter = [];
  public vehiclesclassificationFilter = [];
  public yearList = [];
  public generationList = [];
  public generationListOriginal = [];
  public yearListOriginal = [];
  public hasPermission = false;
  public hasEditPermission = false;
  public internalFeat: string[] = [];
  public externalFeat: string[] = [];
  public vehicleModels: Vehicle[] = [];

  constructor(
    private vehicleService: ManageVehicleService, private router: Router,
    private adminService: AdminService, private loaderService: LoaderService,
    private dialog: MatDialog, private storageService: TCCPLocalStorageService,
    public commonService: TCCPCommonService) {
  }

  ngOnInit() {
    this.vehiclesFilter = [];
    this.getDropdownlist();
    this.storageService.setCachedFeatures(null);
    this.storageService.setCachedFeatures(this.dropdownList);
    this.getAllVehicles();
    const roles: string[] = this.storageService.getRoles();
    const userAccess = this.commonService.getAccess('Model and Year', roles);
    const accessLevel = _.get(userAccess[0], 'accessLevel');
    if (accessLevel === 1) {
      this.hasPermission = true;
    }

    if (accessLevel === 3) {
      this.hasPermission = false;
    }
    this.adminService.refreshToVehicle.subscribe(data => {
      if (data) {
        this.getAllVehicles();
      }
    });

    this.adminService.modelFilterEmmiter.subscribe(t => {
      if (t && (this.adminService.modelFilter.length > 0 || this.adminService.classificationFilter.length > 0)) {
        this.applyFilter();
      } else {
        this.vehicles = this.adminService.vehicleList;
        this.applyFilter();
      }
    });

    this.adminService.yearFilterEmmiter.subscribe(t => {
      if (t && (this.adminService.yearFilter.length > 0)) {
        this.applyFilter();
      } else {
        this.vehicles = this.adminService.vehicleList;
        this.applyFilter();
      }
    });

    this.adminService.generationFilterEmmiter.subscribe(t => {
      if (t && (this.adminService.generationFilter.length > 0)) {
        this.applyFilter();
      } else {
        this.vehicles = this.adminService.vehicleList;
        this.applyFilter();
      }
    });
  }

  getDropdownlist() {
    this.adminService.getFlow().subscribe((data: any) => {
      data.filter(control => {
        control.controls.filter(obj => {
          this.dropdownList = this.dropdownList.concat({
            issueId: control.issueId,
            featureName: obj.featureName, featureType: control.featureType
          });
        });
      });
      this.storageService.setCachedFeatures(null);
      this.storageService.setCachedFeatures(this.dropdownList);
    });
  }

  ngAfterViewInit() {
    this.vehicleService.statusMessage.subscribe(data => {
      this.showAlertMessages(data.type, data.message);
    });
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  getInternalFeatures(vehicleFeatures: string[], supportFeatures: any): string[] {
    this.internalFeat = [];
    if (!_.isNil(vehicleFeatures) && !_.isNil(supportFeatures)) {
      vehicleFeatures.forEach(vehicleFeature => {
        supportFeatures.forEach(supportFeature => {
          if (vehicleFeature === _.get(supportFeature, 'issueId') && _.get(supportFeature, 'featureType') === 'internal') {
            this.internalFeat.push(_.get(supportFeature, 'featureName'));
          }
        });
      });
    }
    return this.internalFeat;
  }


  getExternalFeatures(vehicleFeatures: string[], supportFeatures: any): string[] {
    this.externalFeat = [];
    if (!_.isNil(vehicleFeatures) && !_.isNil(supportFeatures)) {
      vehicleFeatures.forEach(vehicleFeature => {
        supportFeatures.forEach(supportFeature => {
          if (vehicleFeature === _.get(supportFeature, 'issueId') && _.get(supportFeature, 'featureType') === 'external') {
            this.externalFeat.push(_.get(supportFeature, 'featureName'));
          }
        });
      });
    }
    return this.externalFeat;
  }

  getVehiclesViewList(vehicleList: Vehicle[]): Vehicle[] {
    this.vehicleModels = [];
    const supportFeatures = JSON.parse(JSON.stringify(this.storageService.getCachedFeatures()));
    vehicleList.forEach(vehicleModel => {
      const years = _.get(vehicleModel, 'years');
      years.forEach(modelYear => {
        const modelInstance: Vehicle = {
          model: _.get(vehicleModel, 'model'),
          year: _.get(modelYear, 'year'),
          years: _.get(vehicleModel, 'years'),
          generation: _.get(modelYear, 'generation'),
          classification: _.get(vehicleModel, 'classification'),
          modelCodes: _.get(vehicleModel, 'modelCodes'),
          order: vehicleModel.order,
          internal: this.getInternalFeatures(_.get(modelYear, 'features'), supportFeatures),
          external: this.getExternalFeatures(_.get(modelYear, 'features'), supportFeatures)
        };
        this.vehicleModels.push(modelInstance);
      });
    });
    return this.vehicleModels;
  }

  getAllVehicles() {
    this.loaderService.show();
    if (!_.isNil(this.storageService.getCachedVehicles())) {
      const vehicles = JSON.parse(JSON.stringify(this.storageService.getCachedVehicles()));
      this.getVehiclesViewList(vehicles);
    }
    this.vehicleService.getAllVehicle().subscribe((data: any) => {
      this.loaderService.hide();
      this.vehicles = this.adminService.vehicleList = data;
      this.storageService.setCachedVehicles(null);
      this.storageService.setCachedVehicles(this.vehicles);
      this.getVehiclesViewList(this.vehicles);
      this.adminService.filterdModelList = data;
      data.forEach((dataobj, index) => {
        this.yearList = data.map(x => x.years);
      });
      this.yearList.forEach((dataobj, index) => {
        this.yearList[index].forEach((dataobj, index) => {
          this.yearListOriginal.push(dataobj.year);
          if (dataobj.generation !== null || dataobj.generation !== '') {
            this.generationListOriginal.push(dataobj.generation);
          }
        });
      });
      this.generationListOriginal.sort(this.sortByClassification());
      this.yearListOriginal.sort(this.sortByYear());
      this.yearListOriginal.forEach((elem, i) => {
        return elem.toString().trim();
      });

      this.adminService.yearList = this.yearListOriginal.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return (elem);
        }
      });

      this.adminService.generationList = this.generationListOriginal.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return (elem);
        }
      });
      this.adminService.vehicleClassification = data.map(x => x.classification);
      this.adminService.vehicleClassification.sort(this.sortByClassification());
      if (this.adminService.modelFilter.length > 0) {
        this.adminService.modelFilterEmmiter.emit(true);
      }
      if (this.adminService.yearFilter.length > 0) {
        this.adminService.yearFilterEmmiter.emit(true);
      }
      if (this.adminService.classificationFilter.length > 0) {
        this.adminService.modelFilterEmmiter.emit(true);
      }
      if (this.adminService.generationFilter.length > 0) {
        this.adminService.generationFilterEmmiter.emit(true);
      }
    }, error => {
      this.loaderService.hide();
    });

  }

  public sortByClassification = () => {
    return (x, y) => (x === y) ? 0 : ((x > y) ? 1 : -1);
  }
  public sortByYear = () => {
    return (x, y) => {
      return (x === y) ? 0 : ((x < y) ? 1 : -1);
    };
  }

  filterByGeneration(vehicles: any) {
    this.generationFilter = [];
    this.adminService.generationFilter.forEach(element1 => {
      vehicles
        .filter(x => x.years
          .some(y => y.generation === element1))
        .map(x => {
          const n = Object.assign({}, x, {
            years: x.years.filter(
              years => years.generation === element1)
          });
          if (n) {
            this.generationFilter.push(n);
          }
        });
    });
    return this.generationFilter;
  }

  filterByClassfication(vehicles: any) {
    this.vehiclesclassificationFilter = [];
    this.vehiclesclassificationFilter = (vehicles.filter((t) =>
      this.adminService.classificationFilter.includes(t.classification)));
    return this.vehiclesclassificationFilter;
  }

  filterByModel(vehicles: any) {
    this.vehiclesModelFilter = (vehicles.filter((t) =>
      this.adminService.modelFilter.indexOf(t.model) > -1
      , this));
    return this.vehiclesModelFilter;
  }

  filterByYear(vehicles: any) {
    this.yearFilter = [];
    this.adminService.yearFilter.forEach(element1 => {
      vehicles
        .filter(x => x.years
          .some(y => y.year === parseInt(element1, 10)))
        .map(x => {
          const n = Object.assign({}, x, {
            years: x.years.filter(
              years => years.year === parseInt(element1, 10))
          });
          if (!_.isEmpty(this.adminService.modelFilter)) {
            if (this.adminService.modelFilter.includes(n.model)) {
              this.yearFilter.push(n);
            }
          } else {
            this.yearFilter.push(n);
          }
        });
    });
    return this.yearFilter;
  }

  applyFilter() {
    let isFiltered = false;
    this.vehicles = this.storageService.getCachedVehicles();
    this.adminService.vehicleFilteredList = this.adminService.vehicleList;
    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.modelFilter)
      && !_.isEmpty(this.adminService.generationFilter) && !_.isEmpty(this.adminService.yearFilter) && !isFiltered) {
      this.vehicles = this.filterByClassfication(this.adminService.vehicleFilteredList);
      this.vehicles = this.filterByModel(this.vehicles);
      this.vehicles = this.filterByYear(this.vehicles);
      this.vehicles = this.filterByGeneration(this.vehicles);
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      this.adminService.vehicleFilteredList = [];
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.modelFilter)
      && !_.isEmpty(this.adminService.yearFilter) && !isFiltered) {
      this.vehicles = this.filterByClassfication(this.adminService.vehicleFilteredList);
      this.vehicles = this.filterByModel(this.vehicles);
      this.vehicles = this.filterByYear(this.vehicles);
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      this.adminService.vehicleFilteredList = [];
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.modelFilter)
      && !_.isEmpty(this.adminService.generationFilter) && !isFiltered) {
      this.vehicles = this.filterByClassfication(this.adminService.vehicleFilteredList);
      this.vehicles = this.filterByModel(this.vehicles);
      this.vehicles = this.filterByGeneration(this.vehicles);
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.modelFilter) && !isFiltered) {
      this.vehicles = this.filterByClassfication(this.adminService.vehicleFilteredList);
      this.vehicles = this.filterByModel(this.adminService.vehicleFilteredList);
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.modelFilter) &&
      !_.isEmpty(this.adminService.generationFilter) && !isFiltered) {
      this.vehicles = this.filterByClassfication(this.adminService.vehicleFilteredList);
      this.vehicles = this.filterByModel(this.adminService.vehicleFilteredList);
      this.vehicles = this.filterByGeneration(this.vehicles);
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      this.adminService.vehicleFilteredList = [];
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.modelFilter) && !_.isEmpty(this.adminService.yearFilter) && !isFiltered) {
      this.vehicles = this.filterByModel(this.vehicles);
      this.vehicles = this.filterByYear(this.vehicles);
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      this.adminService.vehicleFilteredList = [];
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.generationFilter) && !isFiltered) {
      this.vehicles = this.filterByGeneration(this.filterByClassfication(this.adminService.vehicleFilteredList));
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !_.isEmpty(this.adminService.yearFilter) && !isFiltered) {
      this.vehicles = this.filterByYear(this.filterByClassfication(this.adminService.vehicleFilteredList));
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.generationFilter) && !isFiltered) {
      this.vehicles = this.filterByGeneration(this.adminService.vehicleFilteredList);
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.classificationFilter) && !isFiltered) {
      this.vehicles = this.filterByClassfication(this.adminService.vehicleFilteredList);
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }

    if (!_.isEmpty(this.adminService.modelFilter) && !isFiltered) {
      this.vehicles = this.filterByModel(this.adminService.vehicleFilteredList);
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }
    if (!_.isEmpty(this.adminService.yearFilter) && !isFiltered) {
      this.vehicles = this.filterByYear(this.adminService.vehicleFilteredList);
      this.adminService.vehicleFilteredList = [];
      this.vehicleModels = this.getVehiclesViewList(this.vehicles);
      isFiltered = true;
    }
  }

  editVehicle(vehicle: Vehicle, year: number) {
    this.vehicleService.vehicleYear = year;
    this.vehicleService.vehicle = vehicle;
    this.router.navigate(['/admin/addVehicle']);
  }

  deleteVehicle(vehicle: Vehicle, year: number) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the Vehicle Model?',
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (vehicle.years.length > 1) {
          this.updateVehicle(vehicle, year);
        } else {
          this.deleteVehicleModel(vehicle.model);
        }
      }
    });
  }

  updateVehicle(vehicle: Vehicle, year: number) {
    const vech = vehicle.years.indexOf(vehicle.years.filter(x => x.year === year)[0]);
    vehicle.years.splice(vech, 1);
    this.vehicleService.updateVehicle(vehicle).subscribe(data => {
      this.getAllVehicles();
    });
  }

  deleteVehicleModel(model: string) {
    this.vehicleService.deleteVehicle(model).subscribe(data => {
      this.getAllVehicles();
    });
  }

}
